import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { T } from "../../constants";
import { useUi, cx } from "../../ui";
import LoadingIndicator from "../../../../components/LoadingIndicator";
import ForecastPlot, { CHART_HEIGHT } from "./ForecastPlot";
import { hasCapacity } from "../forecastSummary";

const useStyles = makeStyles({
  legend: {
    marginBottom: 12,
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    columnGap: 16,
    rowGap: 4,
  },
  legendArrivals: { color: T.successText },
  legendDepartures: { color: T.primary },
  legendItem: { display: "flex", alignItems: "center", gap: 4, textTransform: "none", color: T.mutedFg },
  legendItemRight: { marginLeft: "auto", display: "flex", alignItems: "center", gap: 4, textTransform: "none", color: T.mutedFg },
  legendLineSolid: { display: "inline-block", height: 2, width: 16, background: T.fg },
  legendLineDashed: { display: "inline-block", height: 0, width: 16, borderTop: `1px dashed ${T.danger}` },
  box: {
    boxSizing: "border-box",
    height: CHART_HEIGHT + 26, // plot + 12px padding each side + 1px borders
    borderRadius: 6,
    border: `1px solid ${T.border}`,
    background: T.surface,
    padding: 12,
  },
  message: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 6,
    fontSize: 12,
    color: T.mutedFg,
    textAlign: "center",
  },
  error: { background: T.dangerTint, color: T.danger },
});

export default function FlowForecastChart({ loading, failed, ...plot }) {
  const s = useStyles();
  const ui = useUi();
  const capped = hasCapacity(plot.capacity);

  return (
    <>
      <div className={cx(s.legend, ui.eyebrow)}>
        <span className={s.legendArrivals}>Arrivals</span>
        <span className={s.legendDepartures}>Departures</span>
        <span className={s.legendItemRight}>
          <span className={s.legendLineSolid} aria-hidden /> Projected occupancy
        </span>
        {capped && (
          <span className={s.legendItem}>
            <span className={s.legendLineDashed} aria-hidden /> Capacity {plot.capacity}
          </span>
        )}
      </div>

      <div className={s.box}>
        {failed ? (
          <div className={cx(s.message, s.error)} data-testid="chart-error">
            Could not load the forecast.
          </div>
        ) : loading ? (
          <div className={s.message} data-testid="chart-loading">
            <LoadingIndicator />
          </div>
        ) : (
          <ForecastPlot {...plot} />
        )}
      </div>
    </>
  );
}
